import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useHistory } from "react-router";
import moment from 'moment-timezone'
import "react-datepicker/dist/react-datepicker.css";
import { BBBCommand,  GetRecordingCeckerListCancelToken, ResubmitView } from "../../../services/ClassMgtService";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import $ from 'jquery';
import { Link } from "react-router-dom";
import { convertToLocalDate, handleTableScroll } from "../../../utils/commonFunction";
import axios from "axios";
import DataTableComponent from "../../common/DataTableComponent";

const OnlineClassChecker = () => {

  const history = useHistory();
  const [dataArr, setDataArr] = useState([]);
  const [viewBId, setViewBid] = useState("");
  const [downloadBId, setDownloadBid] = useState("");
  const [search, setSearch] = useState("");
  const [serverRes, setServerRes] = useState("");
  const [loading,setloading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [tableState, setTableState] = useState({
    page: 1,
    perPage: 10,
    sortKey: "start_date",
    sortOrder: "asc",
  });

  useEffect(() => {
    handleTableScroll()
  }, [loading])
useEffect(() => {
  const dropdownSource = axios.CancelToken.source();
  setloading(true);

  const fetchData = async () => {
    try {
      const payload = {
        key: tableState.sortKey,
        pageNo: tableState.page,
        limit: tableState.perPage,
        exportStatus: "true",
        viaSearch: search
      };

      const res = await GetRecordingCeckerListCancelToken(payload,dropdownSource.token);

      if (res?.status == 200) {

        const localTzClassesList = res.data?.data?.map(row => {
          const classListData = convertToLocalDate(row);

          return {
            ...row,
            start_date: classListData.class_date,
            start_time: classListData.class_from,
            end_time: classListData.class_to,
          };
        });

        setDataArr(localTzClassesList || []);
        setTotalRows(res.data.pagination?.totalPages);
        setloading(false);
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error(error);
        setloading(false);
      }
    }
  };

  fetchData();

  return () => {
      dropdownSource.cancel('Component unmounted');
  };
}, [tableState, search]);


  const columns = [
    {
      name: "Title",
      selector: "class_title",
      sortField: "class_title",
      sortable: false,
      cell: (row) => {
        return <div className="assigned-title-block-new">
          <div className="dashboard-message-count">
            <div className="assigned-title-itm overflow-ellipsis2 fst_line2">
              <Link
                className="as-text-blue curser textLimit2"
                to={`/courseAdministration/coursesdetails/${row?.intake_id}/onlineClasses/show`}
                title={row?.class_title + " " + row?.class_id}
              >
                {row?.class_title ? row?.class_title + " " + row?.class_id : "-"}
              </Link>
            </div>
          </div>
        </div>
      }
    },
    {
      name: "Class ID",
      selector: "big_blue_button_id",
      sortField: "big_blue_button_id",
      sortable: false,
      cell: (row) => {
        return <span className="feature-name"><span className="textLimit100">{row?.big_blue_button_id ? row?.big_blue_button_id : "-"}</span></span>
      }
    },
    {
      name: "Date",
      selector: "start_date",
      sortField: "start_date",
      sortable: false,
      cell: (row) => (
        <>{row.start_date ?
          <div className="dateTime">
            <p className="right-space">{row.start_date}</p>
            <p>{row.start_time} - {row.end_time}</p>
          </div>
          : "-"
        }</>
      )
    },
    {
      name: "View Rendering Duration",
      selector: "eviewDuration",
      cell: (row) => (
        <p>{row?.eviewDuration ? `${row?.eviewDuration?.d}d :${row?.eviewDuration?.h}h :${row?.eviewDuration?.m}min` : "-"}</p>
      )
    },
    {
      name: "Download Rendering Duration",
      selector: "edownloadDuration",
      cell: (row) => (
        <p>{row?.edownloadDuration ? `${row?.edownloadDuration?.d}d :${row?.edownloadDuration?.h}h :${row?.edownloadDuration?.m}min` : "-"}</p>
      )
    },
    {
      name: "Ended At",
      selector: "end_date",
      sortField: "end_date",
      sortable: false,
      cell: (row) => {
        return (
          <>
            {row.class_to ? (
              <div className="dateTime">
                <p className="right-space">{row.start_date}</p>
                <p>{row.end_time}</p>
              </div>
            ) : "-"}
          </>
        );
      }
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="assessment-08">
          <div className="as-buttons">
            <button className="btn btn-primary rounded-circle" onClick={() => { viewDownloadRecord(row.big_blue_button_id, row.server_id, 'view') }} title="View"><i className="fal fa-eye"></i></button>
            <button className="btn btn-primary rounded-circle" onClick={() => { viewDownloadRecord(row.big_blue_button_id, row.server_id, 'download') }} title="Download"><i className="fal fa-arrow-down"></i></button>
          </div>
        </div>
      ),
    },
  ];

  function viewDownloadRecord(id, server_id = null, type = "view") {
    if (type == "view") {
      setViewBid(id);
      setDownloadBid("");
    } else {
      setDownloadBid(id);
      setViewBid("");
    }
    let formData = new FormData();
    formData.append("action", type);
    formData.append("bbbid", id);
    ResubmitView(formData).then(data => {
      // console.log("data ---> ", data);
      if (data && data.data) {
        if (data.data.status == 0) {
          Swal.fire("", data.data.message, "warning");
        } else if (data.data.status == 1) {
          Swal.fire("", data.data.message, "warning");
        } else if (data.data.status == 2) {
          Swal.fire({
            title: "",
            text: data.data.message,
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Confirm",
          }).then((result) => {
            if (result.isConfirmed) {
              let formDetails = new FormData();
              formDetails.append("action", "LB_runCommand");
              formDetails.append("command", data.data.command);
              formDetails.append("server_id", server_id !== null ? server_id : data.data.server_id);
              $("#roomCampusModal").modal("show");
              BBBCommand(formDetails).then(response => {
                let resMsg = response && response.data && response.data.stdout !== "" ? response.data.stdout : response.data.stderr;
                setServerRes(resMsg);
              }).catch(err => {
                console.log("err >>>> ", err);
              })
            } else {
            }
          })
        }
      }
    }).catch(error => {
      console.log("error ----> ", error);
    })
  }


  const difference = (obj1, obj2) => {
    let keyFound = [];
    Object.keys(obj1).forEach((key) => {
      if (obj1[key] !== obj2[key]) {
        return keyFound.push(key + ":" + obj1[key]);
      }
    });
    return keyFound;
  };

  const oldValue = (row) => {
    const entries = Object.entries(row.description.object.definition?.Old);
    if (row.description.verb.Action === "Edited") {
      const diff = difference(row.description.object.definition?.Old, row.description.object.definition?.New);
      return diff.length !== 0 ? `${diff.sort()}` : "NA";
    }
    // else if (row.description.verb.Action === "Profile Picture Edited") {
    //   return  row.description.object.definition?.Old?.picture_me;
    // }
    else {
      return `${entries.map((entry, index) => `${entry[0]}: ${entry[1] ? entry[1] : "N/A"}`)}`;
    }
  };

  const NewValue = (row) => {
    const entries = Object.entries(row.description.object.definition?.New);
    if (row.description.verb.Action === "Edited") {
      const diff = difference(row.description.object.definition?.New, row.description.object.definition?.Old);
      return diff.length !== 0 ? `${diff.sort()}` : "NA";
    } else if (row.description.verb.Action === "Profile Picture Edited") {
      return row.description.object.definition?.New?.picture_me.toString().length > 30
        ? "picture_me:" + row.description.object.definition?.New?.picture_me
        : row.description.object.definition?.New?.picture_me;
    } else {
      return `${entries.map((entry, index) => `${entry[0]}: ${entry[1] ? entry[1] : "N/A"}`)}`;
    }
  };

const exportData = (fileType, fileName) => {
  let data = [];
  const header = ["Title", "Class ID", "Date", "View Rendering Duration", "Download Rendering Duration", "Ended At"];

  const payload = {
    key: tableState.sortKey,
    pageNo: tableState.page,
    limit: tableState.perPage,
    exportStatus: "false",
    viaSearch: search
  };

  GetRecordingCeckerListCancelToken(payload)
    .then((res) => {
      if (res?.status === 200) {
        data = res.data || [];
        data = data?.map((row) => {
          const localTzData = convertToLocalDate(row);
          const updatedRow = {
            ...row,
            start_date: localTzData.class_date,
            start_time: localTzData.class_from,
            end_time: localTzData.class_to,
            end_date: localTzData.class_to,
          };

          return {
            "Title": updatedRow?.class_title
              ? `${updatedRow.class_title} ${updatedRow.class_id}`
              : "-",

            "Class ID": updatedRow?.big_blue_button_id || "-",

            "Date": updatedRow?.start_date
              ? `${updatedRow.start_date} ${updatedRow.start_time} - ${updatedRow.end_time}`
              : "-",

            "View Rendering Duration": updatedRow?.eviewDuration
              ? `${updatedRow.eviewDuration.d}d :${updatedRow.eviewDuration.h}h :${updatedRow.eviewDuration.m}min`
              : "-",

            "Download Rendering Duration": updatedRow?.edownloadDuration
              ? `${updatedRow.edownloadDuration.d}d :${updatedRow.edownloadDuration.h}h :${updatedRow.edownloadDuration.m}min`
              : "-",

            "Ended At": updatedRow?.end_date
              ? `${updatedRow.start_date} ${updatedRow.end_time}`
              : "-",
          };
        });

        if (fileType === "csv") {
          const csvString = Papa.unparse({ fields: header, data });
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

          const blobURL = window.URL.createObjectURL(blob);

      // Create new tag for download file
          const anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = blobURL;
          anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(":");
          anchor.click();

      // Remove URL.createObjectURL. The browser should not save the reference to the file.
          setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
            URL.revokeObjectURL(blobURL);
          }, 1000);
    } else if (fileType === "xlsx") {
          const compatibleData = data.map((row) => {
            const obj = {};
        header.map((col, index) => {
              obj[col] = row[col];
            });
            return obj;
          });

          let wb = XLSX.utils.book_new();
      let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
        header,
      });
          XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);

      // Returning false as downloading of file is already taken care of
          return false;
        }
        if (fileType === "pdf") {
          const compatibleData = data.map((row) => {
        return [row["Title"], row["Class ID"], row["Date"], row["View Rendering Duration"], row["Download Rendering Duration"], row["Ended At"]];
          });
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: compatibleData,
            columnStyles: {
          0: {
            columnWidth: 40,
          },
          1: {
            columnWidth: 40,
          },
          2: {
            columnWidth: 24,
          },
          3: {
            columnWidth: 24,
          },
          4: {
            columnWidth: 24,
          },
          5: {
            columnWidth: 20,
          },
            },
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);
          return false;
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

  const closeModal = () => {
    $("#roomCampusModal").modal("hide");
    setTimeout(() => { setServerRes(""); }, 1000)
  }

  return (
    <>
      <div className="card card-profile-info-card class-mgt-online-class">
        <div className="card-header pt-0">Check Recording View</div>
        <div className={`card-body `}>
          <div className="card-body-inr card-body-info">
            <div className="row">
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="form-group">
                  <label>Enter BBB ID of Class</label>
                  <input className={"form-control"} name="ViewRecording" value={viewBId} onChange={(e) => { setViewBid(e.target.value) }} />
                </div>
              </div>
            </div>
            <div className="form-group form-group-save-cancel">
              <button className="btn btn-save btn-success" type="button" title="Save" onClick={() => { viewDownloadRecord(viewBId, null, "view") }}>
                <i className="fal fa-save"></i>
                Submit
              </button>
            </div>
            {/* </form> */}
          </div>
        </div>

        <div className="card-header">Check Recording Download</div>
        <div className={`card-body `}>
          <div className="card-body-inr card-body-info">
            <div className="row">
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="form-group">
                  <label>Enter BBB ID of Class</label>
                  <input className={"form-control"} name="DownloadRecording" value={downloadBId} onChange={(e) => { setDownloadBid(e.target.value) }} />
                </div>
              </div>
            </div>
            <div className="form-group form-group-save-cancel">
              <button className="btn btn-save btn-success" type="button" title="Save" onClick={() => { viewDownloadRecord(downloadBId, null, "download") }}>
                <i className="fal fa-save"></i>
                Submit
              </button>
            </div>
            {/* </form> */}
          </div>
        </div>

        <div className="card-header">Classes in Danger Zone</div>
        <DataTableComponent
          isInsidePopUp={true}
          classNam="p-0"
          data={dataArr}
          columns={columns}
          loading={loading}
          setSearch={setSearch}
          state={tableState}
          setState={setTableState}
          totalRows={totalRows}
          exportFunction={exportData}
          exportFileName={"Class_In_Danger_Zone"}
        />
      </div>

      <div className="topic-add-modal modal fade server-modal" id="roomCampusModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-top modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="font-weight-bold">Command Result</h5>
              <button type="button" className="close" onClick={() => { closeModal() }}>
                {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close"> */}
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="topic-add-modal-content text-center">
                {serverRes === "" && <div className="w-100 text-center"><i className="fas fa-cog fa-spin"></i></div>}
                {serverRes !== "" && <pre>{serverRes}</pre>}
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default OnlineClassChecker;

